export const h = {
    'common': {
        'webSuffix': '- QIDI Tech',
        'email': 'Email',
        'password': 'Password',
        'verificationCode': 'Verification Code',
        'username': 'Username',
        'readAndAgree': 'I agree to',
        'and': 'and',
        'userAgreement': 'User Agreement',
        'privacyPolicy': 'Privacy Policy',
        'copy': 'copyright ©  Starting from 2025,QIDI retains ownership',
        'sendVerificationCode': 'Send Verification Code',
        'Sending': 'Sending',
        'tryAgainInSeconds': 'try Again In Seconds',
        "userNameRequired": "Please enter username",
        "passwordInputLabel": "Please enter password",
        "checkPasswordInputLabel": "Please enter a confirmation password",
        "userEmailRequired": "Please enter email address",
        "userEmailInvalid": "Please enter a valid email address",
        "emailCodeRequired": "Please enter verification code",
        "newPasswordInputLabel": "Please enter a new password",
        "confirmPasswordInputLabel": "Please enter your password again",
        "passwordMismatchErrorLabel": "The passwords entered twice are inconsistent",
        "agreementRequired": "Please read and agree to the terms",
        'tip':'tip',
        'tipAlreadyLogin':'Detected that you have logged in, redirected you to the user center',
        'tipWelcomeBack':'welcome back~',
        'tipDeleteAccountFail':'Account deletion failed, account deletion interface is temporarily closed',
        'pleaseAgreeFirst':'Please agree first',
        'agree':'agree',
        'refuse':'refuse',
        'tipNeedLogin':'Please log in first',
        'tipChangePasswordSuccess':'Password changed successfully, we will redirect you to the login page',
        'tipGetUserInfoSuccess':'Successfully obtained information',
        'tipGetUserInfoFail':'Getting information failure',
        'tipLoginOut':'Log out and log in',
        'delete':'Delete',
        'back':'Back',
        "init": "Initialization",

        "passwordInputLengthErrorLabel": "The password length should be between 6 and 20",
        "changePasswordFail": "Original password incorrect",
        "tipDeleteAccountSuccess": "Account deleted successfully",
        "emailCodeSentSuccess": "The verification code has been issued",
        "emailCodeSentFail": "Verification code issuance failed",
        "emailLoginFail": "The verification code has expired",
        "passwordLoginFail": "Login password incorrect",
        "editUserInfoSuccess": "Successfully modified user information",
        "registerSuccess": "registered successfully",
        "registerFail": "login has failed",
        "registerEmailExistFail": "Email already exists",

        "resMessageTip0": "unknown information",
        "resMessageTip1": "Password error",
        "resMessageTip2": "The password length should be between 6 and 20",
        "resMessageTip3": "Account error",
        "resMessageTip4": "The verification code has been issued",
        "resMessageTip5": "Verification code issuance failed",
        "resMessageTip6": "The verification code has expired",
        "resMessageTip7": "Password error",
        "resMessageTip8": "The password cannot be the same as the old password",
        "resMessageTip9": "Email already exists",
        "resMessageTip10": "registered successfully",
        "resMessageTip11": "login has failed",
        "resMessageTip12": "Successfully modified user information",
        "resMessageTip13": "Failed to modify user information",
        "resMessageTip14": "Successfully obtained",
        "resMessageTip15": "Acquisition failed",
        "resMessageTip16": "Password changed successfully",
        "resMessageTip17": "Password change failed",
        "resMessageTip18": "Password reset successful",
        "resMessageTip19": "Password reset failed",
        "resMessageTip20": "Login successful",
        "resMessageTip21": "Login failed",
        "resMessageTip22": "Account deleted successfully",
        "resMessageTip23": "Failed to delete account",
        "resMessageTip24": "The verification code is incorrect",
        "noUserInfoError": "Network error, please log in again"
    },
    'changePassword': {
        'newPassword':'New Password',
    },
    'deleteUser': {
        'tipDeleteUser':'Unfortunately, you are leaving. Once your account is deleted, all your personal data will permanently disappear and cannot be restored.',
        'accountDeletionTerms':'Account Deletion Terms',
    },
    'forgetPassword': {
        'retrievePasswordThroughEmail':'Retrieve Password Through Email',
        'confirmPassword':'Confirm Password',
        'resettingPassword': "Resetting Password",
        'resetting': "Resetting",
    },
    'login': {
        'passwordLogin': 'Password Login',
        'verifyLogin': 'Verify Login',
        'accountRegistration': 'Account Registration',
        'forgotPassword': 'Forgot Password',
        'login': 'Login',
        'localLogin':'Local Login',
        'loginOut':'Log out',
        'continueOnYourWay':'Continue on your way',
    },
    'register': {
        'registerAnAccount': "Register An Account",
        'register': "Register",
    },
    'userCenter': {
        'personalInformation':'Personal Information',
        'modifyInformation':'Modify Information',
        'changePassword':'Change Password',
        'cancelAccount':'Cancel Account',
        'exitAccount':'Exit Account',
        'change':'Change',
        "maxCharLimitTip": "The length of the username cannot exceed 10 Chinese characters",
    },
    'policies': {
        'deleteAccountPrivacy': 'Delete Account Privacy',
        'agreement': 'Agreement',
        'privacyPolicy': 'Privacy Policy',
    },
    "api": {},
    "errorMsg": {},
    'area': {
        'regionalSelection': 'Select Your Country / Region',
        'recommendedVisits': 'Recommended visit',
        'NorthAmerica': 'North America',
        'Europe': 'EU Countries',
        "Asia": "Asia",
        'Other': 'Other',
    },
}
export const aAndL = {
    'ar': {
        'Country': 'Arab',
        'Language': 'Arabic',
    },
    'cs': {
        'Country': 'Czech Republic',
        'Language': 'Czech',
    },
    'de': {
        'Country': 'Germany',
        'Language': 'German',
    },
    'en': {
        'Country': 'United Kingdom',
        'Language': 'English',
    },
    'es': {
        'Country': 'Spain',
        'Language': 'Spanish',
    },
    'fr': {
        'Country': 'France',
        'Language': 'French',
    },
    'he': {
        'Country': 'Israel',
        'Language': 'Hebrew',
    },
    'hu': {
        'Country': 'Hungary',
        'Language': 'Hungarian',
    },
    'it': {
        'Country': 'Italy',
        'Language': 'Italian',
    },
    'ja': {
        'Country': 'Japan',
        'Language': 'Japanese',
    },
    'ko': {
        'Country': 'Korea',
        'Language': 'Korean',
    },
    'nl': {
        'Country': 'Netherlands',
        'Language': 'Dutch',
    },
    'pt': {
        'Country': 'Portugal',
        'Language': 'Portuguese',
    },
    'pt_BR': {
        'Country': 'Portugal (Brazil)',
        'Language': 'Portuguese (Brazil)',
    },
    'ru': {
        'Country': 'Russia',
        'Language': 'Russian',
    },
    'sv': {
        'Country': 'Sweden',
        'Language': 'Swedish',
    },
    'tr': {
        'Country': 'Turkey',
        'Language': 'Turkish',
    },
    'uk': {
        'Country': 'Ukraine',
        'Language': 'Ukrainian',
    },
    'zh': {
        'Country': 'Mainland China',
        'Language': 'Simplified Chinese',
    },
    'zh_tw': {
        'Country': 'China Taiwan',
        'Language': 'Traditional Chinese',
    },
    'Canada': {
        'Country': 'Canada',
        'Language': 'English',
    },
    'United_States': {
        'Country': 'United States',
        'Language': 'English',
    },
    'United_Kingdom': {
        'Country': 'United Kingdom',
        'Language': 'English',
    },
    'EU_Countries': {
        'Country': 'EU Countries',
        'Language': 'English',
    },
    'Australia': {
        'Country': 'Australia',
        'Language': 'English',
    },
    'globalzh': {
        'Country': 'Global',
        'Language': 'Simplified Chinese',
    },
    'globalen': {
        'Country': 'Global',
        'Language': 'English',
    },
}



// WEBPACK FOOTER //
// ./src/i18n/lan/en.js